import { apiClient } from '@/lib/api';
import type {
  AddTeamMemberInput,
  CreateTeamInput,
  TeamDetail,
  TeamListItem,
  TeamMemberData,
  UpdateTeamInput,
} from '../types/team';

const BASE = '/works-lite/teams';

/**
 * The period the returned `utilization` covers (CWL-157). Omitted, the backend
 * defaults to the current week rather than an unbounded figure.
 */
export type TeamsRangeQuery = {
  from: string;
  to: string;
};

function rangeQueryString(range?: TeamsRangeQuery): string {
  if (!range) return '';
  const params = new URLSearchParams({ from: range.from, to: range.to });
  return `?${params.toString()}`;
}

export const teamsService = {
  listTeams(range?: TeamsRangeQuery): Promise<TeamListItem[]> {
    return apiClient.get<TeamListItem[]>(`${BASE}${rangeQueryString(range)}`);
  },

  getTeam(id: number, range?: TeamsRangeQuery): Promise<TeamDetail> {
    return apiClient.get<TeamDetail>(`${BASE}/${id}${rangeQueryString(range)}`);
  },

  createTeam(data: CreateTeamInput): Promise<TeamDetail> {
    return apiClient.post<TeamDetail>(BASE, data);
  },

  updateTeam(id: number, data: UpdateTeamInput): Promise<TeamDetail> {
    return apiClient.patch<TeamDetail>(`${BASE}/${id}`, data);
  },

  deleteTeam(id: number): Promise<{ success: boolean }> {
    return apiClient.delete<{ success: boolean }>(`${BASE}/${id}`);
  },

  getTeamMembers(teamId: number): Promise<TeamMemberData[]> {
    return apiClient.get<TeamMemberData[]>(`${BASE}/${teamId}/members`);
  },

  addTeamMember(teamId: number, data: AddTeamMemberInput): Promise<TeamMemberData> {
    return apiClient.post<TeamMemberData>(`${BASE}/${teamId}/members`, data);
  },

  removeTeamMember(teamId: number, userId: number, newTeamLeadId?: number) {
    const qs = newTeamLeadId !== undefined ? `?newTeamLeadId=${newTeamLeadId}` : '';
    return apiClient.delete<{ success: boolean }>(`${BASE}/${teamId}/members/${userId}${qs}`);
  },
};
